import {io, Socket} from 'socket.io-client';

export class SocketIoClientProvider {
    private socket: Socket<any> | undefined;

    public get(): Socket<any> {
        if (this.socket === undefined) {
            this.socket = io('/');
        }

        return this.socket;
    }
}
